import { MentoringDataType } from "@/types/mentoring"
import { normalizeCalLink } from "@/utils/calendarize"
import CalendarizeEmbed from "./CalendarizeEmbed"

export default function CancelScheduleMentoringModal({
  mentoring,
  onSuccess,
}: {
  mentoring: MentoringDataType
  onSuccess?: () => void
}) {
  return (
    <CalendarizeEmbed
      calLink={normalizeCalLink(mentoring.cancelamentoUrl)}
      onSuccess={onSuccess}
      emptyMessage="Link de cancelamento não disponível para esta mentoria."
    />
  )
}
